import { Text } from '@chakra-ui/react';
import React from 'react';

interface ErrorMessageProps {
    text: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  return (
    <>
        {props.text && (
            <Text textAlign="center" color="red" fontWeight="semibold" mt={4}>
                {props.text}
            </Text>
        )}
    </>
  );
};

export default ErrorMessage;